import React, { useEffect, useState } from 'react';
import '../styles/bubbles.css';
import '../styles/style.css';
import getintouch from "../assets/images/get-touch.png";
import mail from "../assets/images/mail.png";
import phone from "../assets/images/phone.png";
import location from "../assets/images/location.png";
import time from "../assets/images/time.png";
import connectionbanner from "../assets/images/connection-banner.png";
import heroBanner from '../assets/images/hero-banner.png';
import { Helmet } from 'react-helmet';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import conatctvalidationSchema from '../assets/validation/contactform';
import { Link } from 'react-router-dom';
import axios from "axios";

function ContactForm() {

 
  return (
 
      <>
    
  
    {/* <!-- Mouse Cursor Start -->   */}
     <div className="mouse-cursor cursor-outer"></div>
     <div className="mouse-cursor cursor-inner"></div>


    <header className="top-header inner-banner" style={{background: `url(${heroBanner}) no-repeat top center`}}>
      <div id="stars"></div>
      <div id="stars2"></div>
      <div id="stars3"></div>
     <Navbar/>
      <section className="banner-caption flex-center">
        <div className="caption-header text-white">
          <div className="container text-center">
            <h1 className="caption-title"> We’d Love to Hear from You! </h1>
          </div>
        </div>
      </section>
    </header>
    <section className="home-about light-gradient-bg py-5">
      <div className="container">
        <div className="row py-5 align-items-center">
          <div className="col-lg-8">
            <div className="column-left">
              <div className="title mb-5">
                <h1 className="section-title">Get In Touch</h1>
              </div>
              <div className="column-left-content home-about-content">
                <p className="mb-0"> At Entegation Technologies, we’re here to assist you with any inquiries or support you may need. Whether you have questions about our services, want to discuss a potential project, or need technical support, we’re ready to help. </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="column-right">
              <div className="home-about-right d-flex justify-content-end">
                <div className="thumbnail-block">
                  <div className="card-image">
                    <img src={getintouch} alt="contact-image" className="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="career-form py-5">
      <div className="container">
        <div className="row pt-5">
          <div className="col-lg-6">
            <div className="contact-info">
              <div className="our-info d-flex align-items-center">
                <div className="icon-box">
                  <img src={mail} alt="message" />
                </div>
                <div className="detail-box">
                  <p className="contact-label">Email</p>
                  <p><Link to="mailto:contactus@entegation.com">contactus@entegation.com</Link></p>
                </div>
              </div>
              <div className="our-info d-flex align-items-center">
                <div className="icon-box">
                  <img src={phone} alt="phone" />
                </div>
                <div className="detail-box">
                  <p className="contact-label">Phone</p>
                  <p><Link to="tel:6693385227">(669) 338-5227</Link></p>
                </div>
              </div>
              <div className="our-info d-flex align-items-center">
                <div className="icon-box">
                  <img src={location} alt="location" />
                </div>
                <div className="detail-box">
                  <p className="contact-label">Location</p>
                  <p>1702 Cort Ln ,Allen TX 75013</p>
                </div>
              </div>
              <div className="our-info d-flex align-items-center">
                <div className="icon-box">
                  <img src={time} alt="Hours" />
                </div>
                <div className="detail-box">
                  <p className="contact-label">Office Hours</p>
                  <p> Monday - Friday: 9:00 AM - 6:00 PM <br /> Saturday - Sunday: Closed </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="career-contact">
              <Formik 
              initialValues={{
                fullName: '',
                email: '',
                phoneNumber: '',
                subject: '',
                comment: '',
              }}

              validationSchema={conatctvalidationSchema}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                // Simulating form submission
            
                        axios
                          .post(
                            "http://localhost:5000/api/send-contactus",
                            values)
                          .then((response) => {
                            alert(
                              "Contact Form submitted and email sent successfully!"
                            );
                            console.log(response.data, ">>>>>>>>>>");
                          })
                          .catch((error) => {
                            alert("Error sending email!");
                            console.error(error);
                          })
                          .finally(() => {
                            setSubmitting(false);
                            resetForm();
                          });
              }}
              
              >
                 {({ isSubmitting, handleChange, handleBlur }) => (
              <Form>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <div className="form-group">
                        <div className="palceholder">
                          <label htmlFor="name">Full Name</label>
                          <span className="star">*</span>
                        </div>
                        <Field type="text" className="form-control" id="name" name="fullName" required />
                        <ErrorMessage name="fullName" component="div" style={{ color: 'red' }} />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <div className="form-group">
                        <div className="palceholder">
                          <label htmlFor="name">Email Address</label>
                          <span className="star">*</span>
                        </div>
                        <Field type="text" className="form-control" name="email" id="name" required />
                        <ErrorMessage name="email" component="div" style={{ color: 'red' }} />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <div className="form-group">
                        <div className="palceholder">
                          <label htmlFor="name">Phone Number</label>
                          <span className="star">*</span>
                        </div>
                        <Field type="text" className="form-control" name="phoneNumber" id="name" required />
                        <ErrorMessage name="phoneNumber" component="div" style={{ color: 'red' }} />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <div className="form-group">
                        <div className="palceholder">
                          <label htmlFor="name">Subject</label>
                          <span className="star">*</span>
                        </div>
                        <Field type="text" className="form-control" name="subject" id="name" required />
                        <ErrorMessage name="subject" component="div" style={{ color: 'red' }} />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <div className="form-group">
                        <div className="palceholder">
                          <label htmlFor="name">Comments</label>
                          <span className="star">*</span>
                        </div>
                        <Field as="textarea" className="form-control" name="comment" rows="10"/>
                        <ErrorMessage name="comment" component="div" style={{ color: 'red' }} />
                      </div>
                    </div>
                    <button type="submit" disabled={isSubmitting} className="btn btn-theme mt-4 pe-4 ps-4"> Submit </button>
                  </div>
                </div>
              </Form>
                 )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="bottom-bg py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="dark-bg-block">
              <div className="tech-integration d-flex align-items-center">
                <div className="col-lg-5">
                  <div className="contact-info-block text-white">
                    <h1 className="head-medium"> Let’s Build Something Great Together </h1>
                    <p className="py-4"> Got a question or a project in mind? We're here to help. Reach out today, and let's discuss how we can integrate the perfect technology solutions for your business needs. Your next step toward innovation starts here. </p>
                  </div>
                </div>
                <div className="col">
                  <div className="connection-banner d-flex justify-content-end">
                    <img src={connectionbanner} alt="Integration banner" className="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* <!-- footer --> */}
   <Footer/>
    <div className="progress-wrap">
      <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
        <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
      </svg>
    </div>
    <Helmet>
    <title>Entegation Technologies | Contact us</title>
        <script src="/assets/js/script.js"></script>
        <script src="/assets/js/form.js"></script>
    </Helmet>
    </>
   
  )
}

export default ContactForm
